// import {FaRegCalendarAlt} from 'react-icons/fa';
// import {FiMap, FiUsers} from 'react-icons/fi';
// import {RiShieldUserLine} from 'react-icons/ri';
// import {BiCarousel, BiCartAlt, BiErrorAlt} from 'react-icons/bi';
import {BsFileEarmarkPersonFill, BsFileEarmarkPlusFill} from 'react-icons/bs';
// import {DiHtml5Multimedia} from 'react-icons/di';
// import {MdOutlineContactSupport, MdOutlineManageAccounts} from 'react-icons/md';

// import {ImFeed, ImLab} from 'react-icons/im';
// import {GrDatabase, GrNavigate} from 'react-icons/gr';
// import {VscTable, VscTools} from 'react-icons/vsc';
// import {AiOutlineLayout, AiOutlineUnorderedList} from 'react-icons/ai';
import {
  UploadFileOutlined,
  VpnKey,
  Assessment,
  Warning,
  Email as EmailIcon,
  ReportProblem,
} from '@mui/icons-material';

const routesConfig = [
  {
    id: 'client',
    title: 'Clients',
    messageId: 'sidebar.clients',
    type: 'collapse',
    children: [
      {
        id: 'clients',
        title: 'Clients',
        messageId: 'sidebar.app.dashboard.clients',
        type: 'item',
        icon: <BsFileEarmarkPersonFill />,
        url: '/clients/all',
      },
      {
        id: 'addClients',
        title: 'Add Clients',
        messageId: 'sidebar.app.dashboard.addClients',
        type: 'item',
        icon: <BsFileEarmarkPlusFill />,
        url: '/clients/add-client',
      },
      {
        id: 'uploadDataToClients',
        title: 'upload Data To Clients',
        messageId: 'sidebar.app.dashboard.uploadToClient',
        type: 'item',
        icon: <UploadFileOutlined />,
        url: '/clients/upload-data-to-client',
      },
    ],
  },
  {
    id: 'data',
    title: 'Data',
    messageId: 'sidebar.data',
    type: 'collapse',
    children: [
      {
        id: 'data',
        title: 'Data',
        messageId: 'sidebar.app.dashboard.data',
        type: 'item',
        icon: <BsFileEarmarkPersonFill />,
        url: '/data/free-only',
      },
      {
        id: 'dataFreeOnly',
        title: 'Data Free Only',
        messageId: 'sidebar.app.dashboard.dataFreeOnly',
        type: 'item',
        icon: <BsFileEarmarkPersonFill />,
        url: '/data/all',
      },
      {
        id: 'addClients',
        title: 'Add Clients',
        messageId: 'sidebar.app.dashboard.addData',
        type: 'item',
        icon: <BsFileEarmarkPlusFill />,
        url: '/data/upload-data',
      },
      {
        id: 'invalid-data',
        title: 'Incomplete Data',
        messageId: 'sidebar.data.invalid',
        type: 'item',
        icon: <ReportProblem />,
        url: '/invalid-data/all',
      },
      {
        id: 'duplicate-sent-data',
        title: 'Duplicated Data',
        messageId: 'sidebar.data.duplicateSent',
        type: 'item',
        icon: <Warning />,
        url: '/data/duplicated-data',
      },
    ],
  },
  {
    id: 'employees',
    title: 'Employees',
    messageId: 'sidebar.ecommerce.employee',
    type: 'collapse',
    children: [
      {
        id: 'employees',
        title: 'Employees',
        messageId: 'sidebar.ecommerce.employee',
        type: 'item',
        icon: <BsFileEarmarkPersonFill />,
        url: '/employees/all',
      },
      {
        id: 'addEmployees',
        title: 'Add Employees',
        messageId: 'sidebar.ecommerce.addemployee',
        type: 'item',
        icon: <BsFileEarmarkPlusFill />,
        url: '/employees/add-employee',
      },
    ],
  },
  {
    id: 'reports',
    title: 'Reports',
    messageId: 'sidebar.ecommerce.archive',
    type: 'collapse',
    children: [
      {
        id: 'add_data',
        title: 'Database Archive',
        messageId: 'sidebar.ecommerce.dataSave',
        type: 'item',
        icon: <BsFileEarmarkPersonFill />,
        url: '/Reports/DataSave',
      },
      {
        id: 'sent_data',
        title: 'Sent data Archive',
        messageId: 'sidebar.ecommerce.dataSent',
        type: 'item',
        icon: <BsFileEarmarkPersonFill />,
        url: '/Reports/DataSent',
      },
    ],
  },
  {
    id: 'customer-cross-check-reports',
    title: 'Customer Reports',
    messageId: 'sidebar.reports.customer',
    type: 'collapse',
    children: [
      {
        id: 'daily_reports',
        title: 'Daily Reports',
        messageId: 'sidebar.reports.daily',
        type: 'item',
        icon: <Assessment />,
        url: '/Reports/DailyReports',
      },
      {
        id: 'customer_cross_check',
        title: 'Customer Cross Check Report',
        messageId: 'sidebar.reports.customerCrossCheck',
        type: 'item',
        icon: <Assessment />,
        url: '/Reports/CustomerCrossCheck',
      },
    ],
  },
  {
    id: 'api-credentials',
    title: 'API Credentials',
    messageId: 'sidebar.data.apiCredentials',
    type: 'item',
    icon: <VpnKey />,
    url: '/api-credentials/all',
  },
  {
    id: 'forms',
    title: 'Forms',
    messageId: 'sidebar.ecommerce.forms',
    type: 'collapse',
    children: [
      {
        id: 'forms',
        title: 'Forms',
        messageId: 'sidebar.ecommerce.accessableforms',
        type: 'item',
        icon: <BsFileEarmarkPersonFill />,
        url: '/forms/Allfroms',
      },

      {
        id: 'htmlFormGen',
        title: 'HtmlFormGen',
        messageId: 'sidebar.ecommerce.htmlFormGen',
        type: 'item',
        icon: <BsFileEarmarkPersonFill />,
        url: '/forms/htmlFormGen',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    messageId: 'sidebar.settings',
    type: 'collapse',
    children: [
      {
        id: 'email-settings',
        title: 'Email Configuration',
        messageId: 'sidebar.settings.email',
        type: 'item',
        icon: <EmailIcon />,
        url: '/settings/email-configuration',
      },
    ],
  },
];
export default routesConfig;
